import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  uriApi = environment.api_url;
  constructor(private http: HttpClient) {}

  charge(data: { token: string, packType: string }): Observable<any> {
    let options = {
          headers: new HttpHeaders({
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('currentUser'))['token']
          })
        };
    return this.http.post(this.uriApi + '/payment/charge', data, options);
  }

  sendForStripe(): Observable<any> {
    let options = {
          headers: new HttpHeaders({
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('currentUser'))['token']
          })
        };
    return this.http.post(this.uriApi + '/stripe/checkout', {}, options);
  }

  createCheckoutSession(data: { packType: string }): Observable<any> {
    let options = {
          headers: new HttpHeaders({
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('currentUser'))['token']
          })
        };
    return this.http.post(this.uriApi + '/create-checkout-session', data, options);
  }

  upgradeCheckoutSession(data: { packType: string }): Observable<any> {
    let options = {
          headers: new HttpHeaders({
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('currentUser'))['token']
          })
        };
    return this.http.post(this.uriApi + '/upgrade-pack', data, options);
  }

  // Récupérer le montant à payer maintenant (prorata)
  getUpgradePreview(data: { packType: string }): Observable<any> {
    let options = {
          headers: new HttpHeaders({
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('currentUser'))['token']
          })
        };
    return this.http.post(this.uriApi + '/preview-upgrade-pack', data, options);
  }
}
